import { createFileRoute } from "@tanstack/react-router"

import config from "@/config"

import { ReceiptsInboxPage } from "../components/inbox/receipts-inbox-page"

export const Route = createFileRoute("/_app-shell/settings/receipts-inbox")({
  head: () => ({
    meta: [
      { title: `Forward receipts - ${config.core.projectName}` },
      { name: "robots", content: "noindex" },
    ],
  }),
  component: ReceiptsInboxPage,
})
